module.exports = __webpack_public_path__ + "assets/font/SourceHanSansKR-Normal-4111094d.woff2";